import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { NbAuthModule, NbDummyAuthStrategy } from '@nebular/auth'

import { NbEvaIconsModule } from '@nebular/eva-icons'
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
  NbTooltipModule,
  NbUserModule,
} from '@nebular/theme'
import { AgGridModule } from 'ag-grid-angular'
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-grid-enterprise'
import { AirtableService } from './airtable/airtable.service'
import { AppComponent } from './app.component'
import { appRoutes } from './app.routes'
import { AuthGuard } from './guards/auth-guard.service'
import { DARK_THEME } from './theme/theme.dark'

LicenseManager.setLicenseKey(
  '💙eliumtech💙_MjUyMzYyMzU3MDAwMA==55d70ec2d91a3ca2936120126cc01241'
)
ModuleRegistry.registerModules([AllEnterpriseModule])

@NgModule({
  declarations: [AppComponent],
  imports: [
    AgGridModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NbAuthModule.forRoot({
      strategies: [
        NbDummyAuthStrategy.setup({
          name: 'email',
        }),
      ],
      forms: {},
    }),
    NbThemeModule.forRoot(DARK_THEME),
    NbLayoutModule,
    NbTooltipModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbUserModule,
    NbActionsModule,
    NbCardModule,
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbSearchModule,
    NbSidebarModule.forRoot(),
    NbContextMenuModule,
    NbUserModule,
    NbButtonModule,
    NbSelectModule,
    NbIconModule,
    NbEvaIconsModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
  ],
  providers: [AirtableService, AuthGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}
